module.exports = __webpack_public_path__ + "img/collect.41204cc.png";